<div class="overlay" id="{{config?.id}}" [ngClass]="{'overlaycolor': config?.hasBackdrop != false }"
    (click)="onOverlayClicked($event)">
    <div class="dialog popup-drawer plan-details {{config?.panelClass}}"
        [ngClass]="{'drawerMinimize': drawerMinimized, 'compare-full': CompareBack }" id="dialog"
        (click)="onDialogClicked($event)" [ngStyle]="{ 
        'width':config?.width ? config?.width : 'auto',
        'height':config?.height ? config?.height : 'auto',
        'minWidth':config?.minWidth ? config?.minWidth : 'auto',
        'minHeight':config?.minHeight ? config?.minHeight : 'auto',
        'maxWidth':config?.maxWidth ? config?.maxWidth : 'auto',
        'maxHeight':config?.maxHeight ? config?.maxHeight : 'auto',
        'top':config?.position?.top ? config?.position.top : 'auto',
        'bottom':config?.position?.bottom ? config?.position?.bottom : 'auto',
        'left':config?.position?.left ? config?.position?.left : 'auto',
        'right':config?.position?.right ? config?.position?.right : 'auto'}">
        <div class="hide-desktop-xm center minimize-line" *ngIf="config?.showMinimizedButton">
            <div class="line" (click)="drawerMinimized = !drawerMinimized"></div>
        </div>
        <div [hidden]=drawerMinimized>
            <ng-template appInsertion>

            </ng-template>
        </div>

    </div>
</div>